import { PlayCircle, Pencil, FileText, HelpCircle, Code, type LucideIcon } from 'lucide-react';
import { LessonType, type Lesson } from '../../types';
import { isSlideBasedContent } from '../../components/course-builder/slides/slideTypes';

export function lessonIcon(lesson: Lesson): LucideIcon {
  const content = lesson.content;
  if (isSlideBasedContent(content)) {
    const templates = content.slides.map(s => s.data.template);
    if (templates.includes('quiz')) return HelpCircle;
    if (templates.includes('reflection')) return Pencil;
    if (
      templates.includes('canva') ||
      templates.includes('media') ||
      templates.includes('webapp') ||
      templates.includes('video')
    ) return PlayCircle;
  }
  switch (lesson.type) {
    case LessonType.VIDEO: return PlayCircle;
    case LessonType.QUIZ: return HelpCircle;
    case LessonType.ASSIGNMENT: return Code;
    default: return FileText;
  }
}

export function countSlideTemplates(lessons: Lesson[]) {
  let quizCount = 0;
  let reflectionCount = 0;
  let mediaCount = 0;
  for (const lesson of lessons) {
    if (!isSlideBasedContent(lesson.content)) continue;
    for (const slide of lesson.content.slides) {
      const t = slide.data.template;
      if (t === 'quiz') quizCount++;
      else if (t === 'reflection') reflectionCount++;
      else if (t === 'canva' || t === 'media' || t === 'webapp' || t === 'video') mediaCount++;
    }
  }
  return { quizCount, reflectionCount, mediaCount };
}
